import { useState } from 'react';
import { apiService } from './apiService'; // Assuming apiService is imported from a separate file
import { useMsal } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";

const useApiRequest = (endpoint: string) => {
  const { instance } = useMsal();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<any>(null);

  const makeRequest = async (method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE", body?: any) => {
    setLoading(true);
    setError(null);

    try {
      const response = await apiService(endpoint, method, body, undefined, instance as PublicClientApplication);
      setData(response);
      return response;
    } catch (err) {
      setError(err instanceof Error ? err.message : "An unknown error occurred.");
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { loading, error, data, makeRequest };
};

export default useApiRequest;